import React from 'react';
import { Divider as MaterialUiDivider, DividerProps } from '@mui/material';
import { ISharedProps } from '../../tools/ISharedProps';
import { VERTICAL_SEPARATOR } from '../../../Constants/Colors.constants';

interface IDividerProps extends DividerProps, ISharedProps {}

export const Divider = ({ ...props }: IDividerProps) => (
  <MaterialUiDivider {...props} style={{ backgroundColor: VERTICAL_SEPARATOR }} />
);
